<mat-form-field appearance="standard" style="width: 100%">
  <mat-label>Wyszukaj</mat-label>
  <input #search matInput [(ngModel)]="query" />
</mat-form-field>
<button mat-raised-button style="margin: 90px auto" (click)="ngOnInit()" *ngIf="error && !loading">Ponów próbę</button>
<mat-spinner *ngIf="loading" style="margin: 90px auto"></mat-spinner>
<div class="accordion-container">
  <ng-container *ngFor="let item of filteredResults$ | async">
    <app-card-block header="Nazwa" [text]="item.name" [value]="item" radio="true" expanded="false" (cardSelected)="radioSelected(item)" [checkboxChecked]="preselectedEup?.eupId == item.eupId">
      <app-card-block-field header="Numer rejestrowy">
        {{ item.registrationNumber }}
      </app-card-block-field>
      <app-card-block-field header="Adres">
        {{ parseAddress(item.address) }}
      </app-card-block-field>
    </app-card-block>
  </ng-container>
</div>
